import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";

const RadioButtonLabel = (props) => {
  const { t, id, service, quantity, unit, product, siteId } = props;

  return (
    <div>
      <Anchor
        url={`/site/view/${siteId}/enquiry-view-${id}`}
        target="_blank"
        rel="noreferrer"
      >
        [{id}]
      </Anchor>
      &nbsp;&nbsp;{t(service)} &nbsp;-&nbsp; {quantity} {t(unit)}&nbsp; - &nbsp;
      {product.name}
    </div>
  );
};

RadioButtonLabel.propTypes = {
  id: PropTypes.number,
  service: PropTypes.string,
  quantity: PropTypes.number,
  unit: PropTypes.string,
  siteId: PropTypes.number,
  product: PropTypes.shape({
    name: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
};
RadioButtonLabel.defaultProps = {
  id: null,
  siteId: null,
  service: false,
  quantity: false,
  unit: false,
  product: {},
};
export default withTranslation()(RadioButtonLabel);
